// extracted by mini-css-extract-plugin
export default {"matrix":"components-settings-cost-advanced-matrix-module__matrix"};